// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"186":"86f5288f","370":"2a4fb2d5","460":"ab2f567c","661":"e9748b86","824":"e9748b86","840":"86f5288f"}[chunkId] + ".chunk.css";
};